import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["for", "innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "mt-[4px] bg-red-100 p-[8px] rounded-[8px] flex items-center gap-[8px] z-[1]"
}
const _hoisted_3 = { class: "text-12 font-semibold text-red-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'has-error': !!$props.errorMessage, success: $props.meta.valid })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex", { 'flex-row items-end justify-between gap-[16px]': $props.labelPosition === 'left', 'flex-col': $props.labelPosition === 'top' }])
    }, [
      ($props.label !== '')
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: $props.name,
            class: _normalizeClass(["block text-xs dark:text-white font-medium uppercase", { ' min-w-[50px]': $props.labelPosition === 'left', '': $props.labelPosition === 'top' }]),
            innerHTML: $props.label
          }, null, 10 /* CLASS, PROPS */, _hoisted_1))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */),
    _createVNode(_Transition, { name: "top-fade" }, {
      default: _withCtx(() => [
        ($props.errorMessage && $props.meta.touched)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode($setup["XCircleIcon"], { class: "h-[16px] fill-red-400" }),
              _createElementVNode("span", _hoisted_3, _toDisplayString($props.errorMessage), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 2 /* CLASS */))
}